export const formatNumber = (num: number) => {
    if (num) {
        if (num >= 1_000_000_000_000) return (num / 1_000_000_000_000).toFixed(3) + ' трлн.';
        if (num >= 1_000_000_000) return (num / 1_000_000_000).toFixed(3) + ' млрд.';
        if (num >= 1_000_000) return (num / 1_000_000).toFixed(2) + ' млн.';
        if (num >= 10000) return (num / 1000).toFixed(1) + ' тыс.';
        return num.toFixed(0);
    }
};

export const getPeriod = (rangeType: string) => {
    switch (rangeType) {
        case 'year': return 'год'
        case 'month': return 'мес.'
        case 'week': return 'нед.'
        case 'custom': return 'пер.'
    }
}
